<app-site-header />
<section class="content-area-layout1">
    <section class="content-area-layout2">
        <h3>Upload Log Files</h3>
        <p class="text-aerostar-orange">{{message}}</p>
        <input type="file" class="file-input" [accept]="requiredFileType" (change)="uploadFile($event)" #logUpload>
        <div class="file-upload">
            <button mat-flat-button (click)="logUpload.click()">Select File</button>
        </div>
        <div style="padding-top: 2rem; width: 50%;">
            @if (percentDone < 100) {
            <mat-progress-bar class="progress-bar" mode="determinate" [value]="percentDone">
            </mat-progress-bar>
            <div style="padding-top: 2rem;">
                <button mat-flat-button (click)="cancelUpload()">Cancel Upload</button>
            </div>
            }
        </div>
    </section>
</section>